import React, { Component } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { PropTypes } from 'prop-types';

import { onEvent } from 'helpers/EventHelpers';
import { trackEvent } from 'helpers/analytics';

import styles from 'styles/components/productdetail/recommendedSizeTooltip.scss';

export class RecommendedSizeTooltip extends Component {
  static propTypes = {
    id : PropTypes.string.isRequired,
    openModal : PropTypes.func.isRequired
  };
  state = {
    hidden : false
  };
  componentDidMount() {
    const { sessionId } = this.props;
    const sessionLastDismissedSizeTooltip = window.localStorage.getItem(this.localStorageKey);
    if (sessionLastDismissedSizeTooltip && sessionId === sessionLastDismissedSizeTooltip) {
      this.setState({ hidden : true });
    }
    onEvent(document, 'click', this.hide, null, this); // allow the tooltip to be dismissed when screen clicked
    onEvent(document, 'keydown', this.onKeyDown, null, this); // allow the tooltip to be dismissed on esc press
  }
  localStorageKey = 'sessionLastDismissedSizeTooltip';
  onKeyDown = e => {
    if (e.key === 'Escape' || e.key === 'Esc') {
      this.hide();
    }
  };
  hide = () => {
    const { sessionId } = this.props;
    this.setState({ hidden : true });
    window.localStorage.setItem(this.localStorageKey, sessionId);
  };
  onClick = () => {
    const { openModal, sessionId } = this.props;
    trackEvent('TE_PDP_SIZE_RECCOMENDER_TOOLTIP', `sessionId : ${sessionId}`);
    openModal();
  };
  render() {
    const { id } = this.props;
    const { hidden } = this.state;
    /*
      https://www.w3.org/TR/wai-aria-practices-1.1/#tooltip
      This is already not a properly accessible tooltip (It is more of a modal that looks like a tooltip)
      because it doesn't show on user input and we can't have the focus on the button this tooltip describes.
      This is because we show this tooltip on page load so having the page scroll to the tooltip is jarring for the user

      buttttt it does everything else right!
    */
    return <div id={id} role="tooltip" className={cn(styles.recommendedSizeTooltip, { [styles.hideTooltip] : hidden })}>
      <div className={cn(styles.fadeIn, styles.delay)}>
        <p>We can help you find your size!</p>
        <p>
          Tell us which shoes fit you well in our
          <button type="button" onClick={this.onClick}>size calculator</button>
          and we can recommend a size that fits you best.
        </p>
      </div>
    </div>;
  }
}

export default connect(state => ({
  sessionId : state.cookies['session-id']
}), {
  trackEvent
})(RecommendedSizeTooltip);
